const PARALLAX_CONFIG = {
  MIN_DELTA: 0.1,
  ADAPTIVE_EASING_MIN: 0.02,
  ADAPTIVE_EASING_MAX: 0.15,
  PARALLAX_FACTOR: 0.7
};

class SimpleParallax {
  constructor(element) {
    this.container = element;
    this.image = element.querySelector('.parallax-image');
    if (!this.image) return;
    this.currentY = 0;
    this.targetY = 0;
    this.handleScroll = this.handleScroll.bind(this);
    this.animate = this.animate.bind(this);
    this.init();
  }

  init() {
    this.checkDevice();
    window.addEventListener('resize', () => this.checkDevice());
  }

  checkDevice() {
    const isDesktop = window.innerWidth >= 992;
    if (isDesktop && !this.isActive) {
      this.isActive = true;
      window.addEventListener('scroll', this.handleScroll);
      this.startAnimation();
      this.handleScroll();
    } else if (!isDesktop && this.isActive) {
      this.isActive = false;
      window.removeEventListener('scroll', this.handleScroll);
      this.stopAnimation();
      if (this.image) {
        this.image.style.transform = 'translateY(0px)';
        this.currentY = 0;
        this.targetY = 0;
      }
    }
  }

  handleScroll() {
    const scrollY = window.pageYOffset;
    const rect = this.container.getBoundingClientRect();
    const containerTop = scrollY + rect.top;
    const windowHeight = window.innerHeight;
     if (scrollY + windowHeight > containerTop && scrollY < containerTop + rect.height) {
       const progress = (scrollY - containerTop + windowHeight) / (windowHeight + rect.height);
       this.targetY = -(progress - 0.5) * windowHeight * PARALLAX_CONFIG.PARALLAX_FACTOR;
     }
  }

  startAnimation() {
    if (!this.animating) {
      this.animating = true;
      this.animate();
    }
  }

  animate() {
    if (!this.animating) return;
    this.smoothUpdateTransform();
    requestAnimationFrame(this.animate);
  }

  smoothUpdateTransform() {
    if (!this.image) return;

    const delta = this.targetY - this.currentY;

    if (Math.abs(delta) > PARALLAX_CONFIG.MIN_DELTA) {
      const adaptiveEasing = this.getAdaptiveEasing(delta);
      this.currentY += delta * adaptiveEasing;
      const transformY = Math.floor(this.currentY);
      this.image.style.transform = `translateY(${transformY}px)`;
    }
  }

  getAdaptiveEasing(delta) {
    const absDelta = Math.abs(delta);
    const normalizedDelta = Math.min(absDelta / 100, 1);
    return PARALLAX_CONFIG.ADAPTIVE_EASING_MIN + 
           (PARALLAX_CONFIG.ADAPTIVE_EASING_MAX - PARALLAX_CONFIG.ADAPTIVE_EASING_MIN) * normalizedDelta;
  }
}
$(document).ready(() => {
  const parallaxElements = document.querySelectorAll('.parallax-bg');
  parallaxElements.forEach(element => {
    new SimpleParallax(element);
  });
});
